import { PageLayout } from '../components/PageLayout'

export function Privacidade() {
  return (
    <PageLayout title="Política de Privacidade" lastUpdated="17 de Janeiro de 2025">
      <section>
        <h2>1. Introdução</h2>
        <p>
          O SecBrain Neurodivergente ("SecBrain", "nós" ou "nossos") está comprometido com a proteção
          da privacidade de seus usuários. Esta Política de Privacidade descreve como coletamos, usamos,
          armazenamos e protegemos suas informações pessoais.
        </p>
        <p>
          Ao utilizar nossa plataforma, você concorda com as práticas descritas nesta política.
          Recomendamos a leitura atenta deste documento.
        </p>
      </section>

      <section>
        <h2>2. Dados que Coletamos</h2>

        <h3>2.1. Dados de Profissionais de Saúde</h3>
        <ul>
          <li><strong>Dados de cadastro:</strong> nome completo, e-mail, telefone, número de registro profissional (CRM, CRP, etc.)</li>
          <li><strong>Dados de acesso:</strong> credenciais de login, registros de acesso, endereço IP</li>
          <li><strong>Dados de uso:</strong> funcionalidades utilizadas, preferências, histórico de navegação na plataforma</li>
          <li><strong>Dados de pagamento:</strong> informações necessárias para processamento de cobranças (processados por terceiros certificados)</li>
        </ul>

        <h3>2.2. Dados de Pacientes</h3>
        <ul>
          <li><strong>Dados de identificação:</strong> nome, data de nascimento, informações de contato do responsável</li>
          <li><strong>Dados clínicos:</strong> relatórios enviados via WhatsApp, informações sobre humor, sono, alimentação, comportamento e medicação</li>
          <li><strong>Dados de acompanhamento:</strong> histórico de relatórios, resumos gerados, alertas</li>
        </ul>

        <h3>2.3. Dados Coletados Automaticamente</h3>
        <ul>
          <li>Informações do dispositivo e navegador</li>
          <li>Dados de cookies e tecnologias similares (veja nossa <a href="/cookies">Política de Cookies</a>)</li>
          <li>Logs de sistema para segurança e performance</li>
        </ul>
      </section>

      <section>
        <h2>3. Como Usamos os Dados</h2>
        <p>Utilizamos os dados coletados para:</p>
        <ul>
          <li><strong>Prestação do serviço:</strong> processar relatórios, gerar resumos, enviar alertas</li>
          <li><strong>Melhoria da plataforma:</strong> análise de uso, desenvolvimento de novas funcionalidades</li>
          <li><strong>Comunicação:</strong> notificações sobre o serviço, atualizações, suporte</li>
          <li><strong>Segurança:</strong> prevenção de fraudes, proteção contra acessos não autorizados</li>
          <li><strong>Cumprimento legal:</strong> atendimento a obrigações legais e regulatórias</li>
        </ul>
      </section>

      <section>
        <h2>4. Bases Legais para o Tratamento</h2>
        <p>O tratamento de dados pessoais é realizado com base nas seguintes hipóteses legais da LGPD:</p>
        <ul>
          <li><strong>Execução de contrato:</strong> para prestação dos serviços contratados</li>
          <li><strong>Consentimento:</strong> quando aplicável, especialmente para comunicações de marketing</li>
          <li><strong>Legítimo interesse:</strong> para melhoria e segurança da plataforma</li>
          <li><strong>Cumprimento de obrigação legal:</strong> quando exigido por lei</li>
          <li><strong>Tutela da saúde:</strong> para dados de saúde, quando aplicável</li>
        </ul>
      </section>

      <section>
        <h2>5. Compartilhamento de Dados</h2>
        <p>Seus dados podem ser compartilhados com:</p>
        <ul>
          <li><strong>Prestadores de serviço:</strong> empresas que nos auxiliam na operação (hospedagem, processamento de pagamentos, análise)</li>
          <li><strong>Parceiros de integração:</strong> como Meta/WhatsApp, para funcionamento da integração</li>
          <li><strong>Autoridades:</strong> quando exigido por lei ou ordem judicial</li>
        </ul>
        <p>
          <strong>Não vendemos dados pessoais.</strong> Todos os prestadores de serviço são contratualmente
          obrigados a proteger seus dados.
        </p>
      </section>

      <section>
        <h2>6. Armazenamento e Segurança</h2>
        <p>Adotamos medidas técnicas e organizacionais para proteger seus dados:</p>
        <ul>
          <li>Criptografia de dados em trânsito (TLS/SSL) e em repouso</li>
          <li>Servidores localizados no Brasil</li>
          <li>Controle de acesso baseado em funções</li>
          <li>Monitoramento contínuo de segurança</li>
          <li>Backups regulares com criptografia</li>
          <li>Isolamento de dados entre organizações (multi-tenancy)</li>
        </ul>
      </section>

      <section>
        <h2>7. Retenção de Dados</h2>
        <p>Mantemos seus dados pelo tempo necessário para:</p>
        <ul>
          <li>Prestação do serviço enquanto você for nosso cliente</li>
          <li>Cumprimento de obrigações legais (ex: registros fiscais por 5 anos)</li>
          <li>30 dias após cancelamento para permitir exportação</li>
        </ul>
        <p>
          Dados de saúde podem ter períodos de retenção específicos conforme regulamentação do setor.
        </p>
      </section>

      <section>
        <h2>8. Seus Direitos</h2>
        <p>
          Você tem direitos garantidos pela LGPD. Para exercê-los, consulte nossa{' '}
          <a href="/lgpd">Política LGPD</a> que detalha:
        </p>
        <ul>
          <li>Direito de acesso aos dados</li>
          <li>Direito de correção</li>
          <li>Direito de exclusão</li>
          <li>Direito de portabilidade</li>
          <li>Direito de revogar consentimento</li>
          <li>E outros direitos previstos em lei</li>
        </ul>
      </section>

      <section>
        <h2>9. Transferências Internacionais</h2>
        <p>
          Alguns de nossos prestadores de serviço podem estar localizados fora do Brasil.
          Nesses casos, garantimos que a transferência é feita com as devidas salvaguardas,
          como cláusulas contratuais padrão ou certificações de adequação.
        </p>
      </section>

      <section>
        <h2>10. Menores de Idade</h2>
        <p>
          Os dados de pacientes menores de idade são coletados e tratados mediante consentimento
          dos pais ou responsáveis legais, sempre no melhor interesse da criança ou adolescente.
        </p>
      </section>

      <section>
        <h2>11. Alterações nesta Política</h2>
        <p>
          Podemos atualizar esta Política de Privacidade periodicamente. Alterações significativas
          serão comunicadas por e-mail ou através da plataforma. A data da última atualização
          está indicada no topo desta página.
        </p>
      </section>

      <section>
        <h2>12. Contato</h2>
        <p>
          Para dúvidas sobre privacidade ou para exercer seus direitos, entre em contato com
          nosso Encarregado de Proteção de Dados (DPO):
        </p>
        <ul>
          <li>E-mail: <a href="mailto:info@secbra.in">info@secbra.in</a></li>
          <li>Endereço: Avenida Júlia Freire, 1200, Sala 109/110/111/112, Expedicionários, João Pessoa - PB, CEP 58041-000</li>
        </ul>
      </section>
    </PageLayout>
  )
}
